import { put, select, takeEvery } from "redux-saga/effects";

import { MLASupplementaryDataAction } from "actions/mlaSupplementaryData";

import {
  SALE_LOT,
  ADD_SALE_LOT_COMMIT,
  DELETE_SALE_LOT_COMMIT,
} from "constants/actionTypes";

import { actionFilters } from "lib/actionFilters";
import { Action } from "redux";

// When a sale lot is updated or fetched by pusher we want to request the MLA data changes
// We can't use pusher as MLA supplementary data doesn't always exist
// (it is just an empty object with a restricted sale lot created when requested)
function* requestMlaDataChanges(): Generator {
  const state: State = (yield select()) as State;
  // This will do nothing if the user has no MLA permissions
  const actions: Action | null = actionFilters[
    MLASupplementaryDataAction.dataType
  ](state, true);
  if (actions) {
    yield put(actions);
  }
}

export default function* mlaSupplementaryDataSaga(): Generator {
  yield takeEvery(
    [ADD_SALE_LOT_COMMIT, DELETE_SALE_LOT_COMMIT, SALE_LOT.UPDATE.SUCCESS],
    requestMlaDataChanges,
  );
  yield takeEvery(SALE_LOT.FETCH_CHANGES.REQUEST, requestMlaDataChanges);
}
